var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { generateMetadata, getRouter } from "../../routing/utils/index.js";
import { Outlet, useParams } from "react-router-dom";
import * as HelmetAsync from "react-helmet-async";
// @ts-ignore
var H = HelmetAsync.default ? HelmetAsync.default : HelmetAsync;
/**
 * App component that represent the entry point of the application
 */
export var Component = function (_a) {
    var AppRouter = _a.router, _b = _a.children, children = _b === void 0 ? undefined : _b;
    // Return children if they exist
    if (children)
        return children;
    var Router = null;
    // Otherwise, get the router and return it
    Router = getRouter(AppRouter);
    return _jsx(Router, {});
};
/**
 * Page component that defines title and description to a page
 */
export var PageToRender = function (_a) {
    var _b, _c;
    var Page = _a.page, data = _a.data, layoutMetadata = _a.layoutMetadata;
    // Get the page props
    var props = data.props || {};
    // get params
    var params = useParams();
    var finalProps = __assign(__assign({}, props), { params: params });
    // Generate meta tags
    var metaTags = React.useMemo(function () {
        var metadatas = [];
        if (Page.metadata)
            metadatas.push(Page.metadata);
        if (layoutMetadata)
            metadatas.push(layoutMetadata);
        return generateMetadata(metadatas);
    }, []);
    return (_jsxs(React.Fragment, { children: [_jsxs(H.Helmet, { children: [metaTags.map(function (meta) { return meta; }), _jsx("meta", { name: "description", content: ((_b = Page.metadata) === null || _b === void 0 ? void 0 : _b.description) || "" }), _jsx("title", { children: ((_c = Page.metadata) === null || _c === void 0 ? void 0 : _c.title) || Page.name })] }), _jsx(Page, __assign({}, finalProps))] }));
};
/**
 * Error fallback component that will be displayed if an error occurs
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false, error: null, info: null };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        this.setState({ hasError: true, error: error, info: info });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, error = _a.error, info = _a.info;
        if (this.state.hasError) {
            return _jsx(ErrorFallbackComponent, { error: error, info: info });
        }
        // @ts-ignore
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
/**
 * Error fallback component that will be displayed if an error occurs
 */
var ErrorFallbackComponent = function (_a) {
    var error = _a.error, info = _a.info;
    return (_jsx("div", { style: {
            width: "calc(100% - 80px)",
            height: "calc(100vh - 80px)",
            padding: "40px",
            backgroundColor: "#fff",
        }, children: _jsxs("div", { children: [_jsx("h1", { style: { fontSize: "2rem" }, children: "Something went wrong" }), _jsx("p", { children: error.toString() }), _jsx("div", { style: {
                        width: "100%",
                        height: "auto",
                        borderRadius: 10,
                        padding: "20px",
                        marginTop: "10px",
                        backgroundColor: "#f0f0f0",
                    }, children: _jsx("p", { children: info.componentStack }) })] }) }));
};
/**
 * Head component
 * @params data - Helmet context
 * @returns
 */
export var Heads = function (_a) {
    var data = _a.data, _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.bootstrap, bootstrap = _c === void 0 ? "" : _c, _d = _a.styles, styles = _d === void 0 ? "" : _d;
    if (!data)
        return null;
    return (_jsxs("head", { children: [children, data.helmet && data.helmet.meta.toComponent({}), data.helmet && data.helmet.title.toComponent({}), bootstrap && (_jsx("script", { type: "module", src: bootstrap, defer: true })), styles && (_jsx("link", { rel: "stylesheet", crossOrigin: "", type: "text/css", href: styles }))] }));
};
/**
 * Body component
 */
export var Body = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.asChild, asChild = _c === void 0 ? false : _c;
    return (_jsxs("body", { children: [_jsx("noscript", { dangerouslySetInnerHTML: {
                    __html: "<b>Enable JavaScript to run this app.</b>",
                } }), asChild ? (_jsx("div", { id: 'root', children: children })) : (_jsxs(_Fragment, { children: [_jsx("div", { id: "root", children: "rasengan-body-app" }), children] }))] }));
};
/**
 * Scripts component
 */
export var Scripts = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.bootstrap, bootstrap = _c === void 0 ? "" : _c;
    var folder = "esm";
    if (typeof exports === "object" && typeof module !== "undefined") {
        folder = "cjs";
    }
    return (_jsxs(React.Fragment, { children: [bootstrap === "" && (_jsx("script", { type: "module", src: "/node_modules/rasengan/lib/".concat(folder, "/entries/entry-client.js"), defer: true })), children] }));
};
/**
 * Default layout component
 */
var DefaultLayout = function () {
    return (_jsx(React.Fragment, { children: _jsx(Outlet, {}) }));
};
DefaultLayout.path = "/";
export { DefaultLayout };
